export const progressStep = [
  { page: 1, title: 'Select package' },
  { page: 2, title: 'Payment details' },
  { page: 3, title: 'Choose coach' },
]

export const coachPackageProgress = [1]
export const coachListingProgressWeb = [1, 2, 3]
export const coachListingProgressTablet = [3]
